/**
 * 系统配置
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectSystemConfigById = (Id) => {
  return get('/api/app/SystemConfig?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddSystemConfig = (data) => {
  return post('/api/app/SystemConfig', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifySystemConfig = (data) => {
  return put('/api/app/SystemConfig', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataSystemConfigList = (data) => {
  return post('/api/app/SystemConfig/list', data, {});
}

/**
 * 保存数据
 * @param {*} data
 * @returns
 */
 export const ModifyAllSystemConfig = (data) => {
  return post('/api/app/SystemConfig/ModifyAll', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteSystemConfig = (id) => {
  return del('/api/app/SystemConfig/' + id, {}, {});
}

